import PropTypes from 'prop-types'
import { StyledHairline } from './component.styles'

const Hairline = ({ className }) => <StyledHairline className={className} />

Hairline.propTypes = {
  className: PropTypes.string,
}

export default Hairline
